import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

// Import required Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export const initProductGallery = (): void => {
  const galleries = document.querySelectorAll<HTMLElement>(
    ".product-gallery-slider",
  );

  if (galleries.length === 0) {
    return;
  }

  galleries.forEach((gallery) => {
    // Prevent double initialization
    if (gallery.dataset.initialized === "true") return;
    gallery.dataset.initialized = "true";

    new Swiper(gallery, {
      modules: [Navigation, Pagination, Autoplay],
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true, // Good UX for product galleries
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  });

  console.log("[Slider] Product Gallery initialized.");
};
